// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "actioncable" + "-" + "672fc41e1fe25fd35154" + ".js";
};